<template>
	<div class="wrapper">
		<side-bar>
			<sidebar-link to="/dashboard">
				<md-icon>dashboard</md-icon>
				<p>Dashboard</p>
			</sidebar-link>
			<!-- <sidebar-link to="/passes">
				<md-icon>check_circle</md-icon>
				<p>All Passes</p>
			</sidebar-link> -->
			<sidebar-link to="/check_ins">
				<md-icon>where_to_vote</md-icon>
				<p>Check-In</p>
			</sidebar-link>
			<!-- <sidebar-link to="/check_outs">
				<md-icon>logout</md-icon>
				<p>Check-Out</p>
			</sidebar-link> -->
			<!-- <sidebar-link to="/search">
				<md-icon>article</md-icon>
				<p>Reports</p>
			</sidebar-link> -->
			<sidebar-link to="/administrators">
				<md-icon>supervised_user_circle</md-icon>
				<p>Administrators</p>
			</sidebar-link>
		</side-bar>

		<div class="main-panel">
			<top-navbar></top-navbar>

			<dashboard-content>

			</dashboard-content>

			<content-footer v-if="!$route.meta.hideFooter"></content-footer>
		</div>
	</div>
</template>

<script>
	import TopNavbar from './TopNavbar.vue'
	import ContentFooter from './ContentFooter.vue'
	import DashboardContent from './Content.vue'

	export default {
		components: {
			TopNavbar,
			DashboardContent,
			ContentFooter
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/DashboardLayout.vue